const AutomationList = async () =>
    import('../../pages/automations/List').then((module) => ({
        Component: module.AutomationList,
    }));

const getAutomationRoutes = (_user) => {
    return [
        {
            path: '/automations/',
            lazy: AutomationList,
        },
    ];
};

export { getAutomationRoutes };
